import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const values = [
  { icon: FiIcons.FiFeather, title: 'Individual Growth', text: 'Every child develops in their own way. We value individual strengths, interests, and milestones.', color: 'green' },
  { icon: FiIcons.FiSun, title: 'Learning Through Discovery', text: 'Encouraging curiosity, exploration, and meaningful experiences as children discover the world around them.', color: 'yellow' },
  { icon: FiIcons.FiHeart, title: 'Care and Connection', text: 'Creating a welcoming atmosphere where children and families feel listened to, respected, and supported.', color: 'red' }
];

export default function Approach() {
  return (
    <section className="section approach" id="approach">
      <div className="container approach-grid">
        <div className="approach-intro"><span className="eyebrow">WHAT MATTERS TO US</span><h2>Growing Together,<br /><span>One Milestone at a Time.</span></h2></div>
        <div className="value-grid">
          {values.map((value) => <article className="value-card" key={value.title}>
            <SafeIcon icon={value.icon} className={`value-icon ${value.color}`} aria-hidden="true" />
            <h3>{value.title}</h3><p>{value.text}</p>
          </article>)}
        </div>
      </div>
    </section>
  );
}